import { Outlet, useLocation } from 'react-router-dom';
import { AppSidebar } from '../../components/blocks/layout/app-sidebar';
// import { UProfileMenu } from '../../components/blocks/u-profile-menu';
import { useSidebar } from 'components/ui/sidebar';
// import { DynamicHeader } from './header/components/DynamicHeader';
// import { ModelSelector } from '../../components/blocks/model-selector';
import { AppFooter } from 'components/blocks/layout/app-footer';
import { SubscriptionPlan } from 'features/subscription';

import GroupChatHeader from '../../features/group-chat/components/GroupChatHeader';

export enum SidebarHeaderVariant {
  Logo = 'logo',
  Icons = 'icons',
}

export interface SidebarHeaderConfig {
  type: SidebarHeaderVariant;
  logo?: string;
  smallLogo?: string;
  open?: boolean;
  isMobile?: boolean;
  setOpenMobile?: (open: boolean) => void;
  strokeWidth?: number;
  toggleSidebar?: () => void;
  onNewChatClick?: () => void;
  onIncognitoClick?: () => void;
  currentPlan?: SubscriptionPlan | null;
  disableNewChat?: boolean;
}

export default function MainLayout() {
  const { open, toggleSidebar } = useSidebar();


  const { pathname } = useLocation();
  const segments = pathname?.split('/').filter(Boolean);
  const firstSegment = segments?.[0] ?? undefined;
  const isEmailRoute = firstSegment === 'mail';


  return (
    <div className="flex w-full min-h-screen relative">
      <div className="absolute left-0 top-0 h-full z-30">
        <AppSidebar
          type={SidebarHeaderVariant.Icons}
          strokeWidth={2}
          toggleSidebar={toggleSidebar}
        />
      </div>

      <div
        className={`flex flex-col w-full h-full overflow-hidden ml-0 ${open ? 'md:ml-[var(--sidebar-width)]' : 'md:ml-[64px]'} transition-[margin-left] duration-300 ease-in-out`}
      >
        <div className="sticky bg-white top-0 p-4  w-full">
          {/* <div className="flex items-center">
            <SidebarTrigger className="mr-1" />
            {hasValidConversationComponentRoute(pathname) && <ModelSelector />}
          </div>
          <div className="flex justify-between items-center gap-1 sm:gap-0 md:gap-4">
            <DynamicHeader />
            <div className="border-l border-gray-300 h-4"></div>
            <UProfileMenu isDropdownIconRequired={!isMobile} isFullNameRequired={!isMobile} />
          </div> */}
          <GroupChatHeader />

        </div>
        <div></div>
        <div
          className={`flex h-full bg-white ${!isEmailRoute && ' px-4 sm:px-6 md:px-8 pb-0'} w-full ${open ? 'md:w-[calc(100vw-var(--sidebar-width))]' : 'md:w-full'}`}
        >
          <Outlet />
        </div>
        <AppFooter />
      </div>
    </div>
  );
}
